import axios from 'axios';

export const getInboundQuantities = async (productIds: number[], warehouseId: number | string | null) => {
  const params = new URLSearchParams();
  productIds.forEach((id) => params.append('productIds', String(id)));
  if (warehouseId != null && warehouseId !== '') {
    params.append('warehouseId', String(warehouseId));
  }
  const response = await axios.get(`/supplyOrders/inbounds?${params.toString()}`);
  return response.data.inboundQuantities;
};
